import React from 'react';
import { BaseFieldProps } from './TextField';
import ProvenanceTooltip from '../layout/ProvenanceTooltip';
import LlmInstructionsTooltip from '../layout/LlmInstructionsTooltip';

interface SelectFieldProps extends BaseFieldProps {
  options: Array<{ value: string; label: string }>;
}

const SelectField: React.FC<SelectFieldProps> = ({
  name,
  label,
  fieldName,
  llmInstructions,
  value,
  onChange,
  provenance,
  confidence,
  onProvenanceClick,
  error,
  required = false,
  disabled = false,
  options,
}) => {
  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-1">
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-700 truncate"
          title={label}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {llmInstructions && <LlmInstructionsTooltip instructions={llmInstructions} />}
      </div>
      <div>
        <select
          id={name}
          name={name}
          value={value || ''}
          onChange={(e) => onChange(name, e.target.value)}
          disabled={disabled}
          className={`mt-1 block w-full rounded-md shadow-sm px-3 py-2 border ${
            error
              ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
          } focus:outline-none focus:ring-1`}
        >
          <option value="">Sélectionner...</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="flex items-center justify-end gap-2 mt-0.5">
          {fieldName && (
            <span
              className="text-[10px] text-gray-300 truncate"
              title={fieldName}
            >
              {fieldName}
            </span>
          )}
          <ProvenanceTooltip snippet={provenance?.snippet} page={provenance?.page} confidence={confidence} fieldLabel={label} onClick={onProvenanceClick} />
        </div>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default SelectField;
